import Vue from 'vue'
import VueRouter from 'vue-router'

// 路由版本："vue-router": 升级路由守卫后；页面跳转问题处理
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, resolve, reject) {
    if ( resolve || reject ) return originalPush.call(this, location, resolve, reject)
    return originalPush.call(this, location).catch((e)=>{})
}

Vue.use(VueRouter)

const routes = [
  {
	path: '/wxck',
	name: 'wxck',
	component: () => import('../view/wxck.vue'),
	meta: { requiresAuth: false, autoLogin: true } // 允许自动登录
  },
  {
    path: '/',
    name: 'login',
    component: () => import('../view/login.vue'),
    meta: { requiresAuth: false, autoLogin: false }
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../view/index.vue'),
    meta: { requiresAuth: true, autoLogin: false } // 需要认证
  },
  // 添加通配符路由，捕获所有未匹配的路径
    {
      path: '*',
      redirect: '/'
    }
]

const router = new VueRouter({
  mode: "hash", // 使用hash模式避免路径问题
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  console.log('=== 详细路由调试信息 ===');
  console.log('完整URL:', window.location.href);
  console.log('路径名:', window.location.pathname);
  console.log('哈希:', window.location.hash);
  console.log('查询参数:', window.location.search);
  // 确保正确定义这些变量
  const currentPath = window.location.pathname; // 添加这行
  const currentHash = window.location.hash;     // 确保这行存在
  console.log('路由守卫执行: ', to.path, '来自: ', from.path);
  
  const token = localStorage.getItem("token");
  const username = localStorage.getItem("username");
  
  console.log('当前token:', token);
  console.log('当前用户名:', username);
  console.log('目标路由meta:', to.meta);
  // 如果哈希是#/index，强制重定向到index路由
    // if (currentHash === '#/index' && to.path !== '/index') {
    //   console.log('检测到哈希路由#/index，重定向到/index路径');
    //   next('/index');
    //   return;
    // }
  
  // 如果当前路径是/wxck，强制进入wxck页面
    if (currentPath === '/wxck' || currentHash === '#/wxck') {
      console.log('检测到/wxck路径访问，强制进入自动登录页面');
      
      // 如果当前路由不是wxck，重定向到wxck
      if (to.path !== '/wxck') {
        next('/wxck');
        return;
      }
      
      next();
      return;
    }
  // 1. 优先处理自动登录页面
    if (to.name === 'wxck') {
      console.log('访问自动登录页面，直接放行');
      next();
      return;
    }
    
    // 2. 处理登录页面
    if (to.name === 'login') {
      console.log('访问登录页面，直接放行');
      next();
      return;
    }
  
  // 3. 检查认证状态
    const isAuthenticated = token && username && username !== 'null';
    
    if (isAuthenticated) {
      console.log('用户已认证，允许访问');
      next();
      return;
    }
    
    // 4. 需要认证但未认证的页面
    if (to.meta.requiresAuth) {
      console.log('页面需要认证但未登录');
      
      // 检查是否来自自动登录页面
      if (from.name === 'wxck') {
        console.log('来自自动登录页面，允许访问');
        next();
        return;
      }
      
      console.log('跳转到登录页面');
      next({
        name: 'login',
        query: {
          redirect: to.path
        }
      });
      return;
    }
    
    // 5. 其他情况直接放行
    console.log('放行到目标页面');
    next();
})

export default router